import React from "react";
import styled from "styled-components";
import {triggerColour} from "../../../../style/styleConsts";
import {AuthorSuggestion} from "./AuthorSuggestion";
import {OrganisationSuggestion} from "./OrganisationSuggestion";

const Suggestion = ({suggestion: {type, data}, isHighlighted}) => {
    switch (type) {
        case "AUTHOR":
            return <AuthorSuggestion data={data} isHighlighted={isHighlighted}/>;
        case "ORGANISATION":
            return <OrganisationSuggestion data={data} isHighlighted={isHighlighted}/>;
        default:
            return null;
    }
};

const Item = styled.li`
    cursor: pointer;
    padding: 10px 15px 10px 10px;
    width: 525px;
    ${props => props.highlighted ? `
        background-color: ${triggerColour};
        color: white;
    ` : ""}
`;

export const SuggestionItem = ({item, index, highlightedIndex, getItemProps}) => {
    return <Item first={index === 0}
                 highlighted={index === highlightedIndex}
                 {...getItemProps({
                     index,
                     item
                 })}>
        <Suggestion suggestion={item} isHighlighted={index === highlightedIndex}/>
    </Item>;
};